var styles = {"checkboxWrapper":"VDS__MON__checkbox-group-item-module__0-J8Y"};

export { styles as default };
